export default __webpack_public_path__ + "static/yo-fro-mango-81cb32902f6c7b58192c981c207ba7ae.png";